module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAATlJREFUaAXtmTEOwjAMRSmwIGaOAFdAbJyElYGdmzAjcQs2Nu4AR4CdBVR+kCrW9rdNVHiRrHaI4+8nB1u012NBAAIQgAAEIAABCEAAAhCAAAT+j0DmpJzn+UR+O9lCNnTOqOHzlO9Ztsmy7FbjnPKuSngvS7325RV/d/a/r5XeZpV2t7PZ0uAmfGgnh0qnWhqsOxxkqZ6XeoQ7PJDFXC8FO+v+nmIGJRYEIAABCMQgUKctjSRwKkvRlq5qS48YgD4x1IPnsnvC2TLEnsdM+Jgw2SL00UnYHS2dWN31CeUk62RJ86PV3bpDOQQgAIEfJFCnLS3F4z/+4tHQsS7mu4TPtVOA7mi5coI17GNpcBO+NCzeOc7S4H4m2UrhWJbyU0vQwIIABCAAAQhAAAIQgAAEIAABCECgBIE32P3FmdE4hQYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/hamburger-white.png
// module id = 2253
// module chunks = 0